import { fetchJsonByDelete, fetchJsonByGet, fetchJsonByPost, fetchJsonByPut } from './execute';
import { getParams } from '../reducers/analyticsApp';
import {
  fromCreateUpdateDashboardResponse,
  fromGetDashboardResponse,
  toNewDashboard,
  toUpdatedDashboard,
} from '../converters/dashboardConverter';

export const getDashboards = () => (dispatch, getState) =>
  fetchJsonByGet('/dashboards/list?full=false', getParams(getState())).then(
    fromGetDashboardResponse
  );

export const createDashboard = () => (dispatch, getState) =>
  fetchJsonByPost('/dashboards', toNewDashboard(getState()), getParams(getState())).then(
    fromCreateUpdateDashboardResponse
  );

export const updateDashboard = () => (dispatch, getState) =>
  fetchJsonByPut('/dashboards', toUpdatedDashboard(getState()), getParams(getState())).then(
    fromCreateUpdateDashboardResponse
  );

export const deleteDashboard = (id) => (dispatch, getState) =>
  fetchJsonByDelete(`/dashboards/${id}`, getParams(getState())).then((response) => ({
    id: response.id,
  }));
